import { render, staticRenderFns } from "./MaintenanceConfigTable.vue?vue&type=template&id=5f6dea14"
import script from "./MaintenanceConfigTable.vue?vue&type=script&lang=js"
export * from "./MaintenanceConfigTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports